function configs(labels, datasets) {
  const chartDatasets = [];
  chartDatasets.push({
    label: datasets.label[0],
    tension: 0.4,
    borderWidth: 0,
    borderRadius: 4,
    borderSkipped: false,
    backgroundColor: datasets.backgroundColor[0],
    data: datasets.data[0],
    maxBarThickness: datasets.sizeWidth || 20,
  });

  // add the second dataset if available otherwise not showing
  if (datasets.data.length >= 2) {
    chartDatasets.push({
      label: datasets.label[1],
      tension: 0.4,
      borderWidth: 0,
      borderRadius: 4,
      borderSkipped: false,
      backgroundColor: datasets.backgroundColor[1],
      data: datasets.data[1],
      maxBarThickness: datasets.sizeWidth || 20,
    });
  }
  return {
    data: {
      labels,
      datasets: chartDatasets,
      // datasets: [
      //   {
      //     label: datasets.label,
      //     tension: 0.4,
      //     borderWidth: 0,
      //     borderRadius: 4,
      //     borderSkipped: false,
      //     backgroundColor: "rgba(255, 255, 255, 0.8)",
      //     data: datasets.data,
      //     maxBarThickness:  20,
      //   },
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: false,
        },
      },
      interaction: {
        intersect: false,
        mode: "index",
      },
      scales: {
        y: {
          beginAtZero: true,
          suggestedMin: 0,
          suggestedMax: 5,
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            suggestedMin: 0,
            suggestedMax: 500,
            beginAtZero: false,
            padding: 10,
            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
            color: "#fff",
          },
        },
        x: {
          grid: {
            drawBorder: false,
            display: true,
            drawOnChartArea: true,
            drawTicks: false,
            borderDash: [5, 5],
            color: "rgba(255, 255, 255, .2)",
          },
          ticks: {
            display: true,
            color: "#f8f9fa",
            padding: 10,

            font: {
              size: 14,
              weight: 300,
              family: "Roboto",
              style: "normal",
              lineHeight: 2,
            },
          },
        },
      },
    },
  };
}

export default configs;
